import classNames from 'classnames';
import { SavingIndicator, SavingIndicatorStatus } from 'components/indicator';
import { usaStatesList } from 'data/location';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IAppOnlyStore } from 'stores/AllStores';

// Styles
const s = require('./StateRepAssignedAreas.css');

// Props
// tslint:disable-next-line:no-empty-interface
interface IStateRepAssignedAreasProps extends IAppOnlyStore {}

// Component
@inject('store')
@observer
export class StateRepAssignedAreas extends React.Component<
    IStateRepAssignedAreasProps,
    {}
> {
    public render() {
        const {
            state: { selectedRepAssignedAreasDetails: rep },
        } = this.props.store;

        if (rep === null) {
            return (
                <div className={s.container}>
                    <h2 className={s.headline}>
                        <SavingIndicator
                            labels={{
                                saving: 'Loading rep areas...',
                            }}
                            status={SavingIndicatorStatus.Saving}
                        />
                    </h2>

                    <br />
                    <br />
                </div>
            );
        }

        return (
            <div className={s.container}>
                <h2 className={s.headline}>{rep.name || rep.slpcode}</h2>

                <div className={s.header}>
                    <div className={s.row}>
                        <div>States</div>
                        <div>Leads count</div>
                    </div>
                </div>

                <div className={s.items}>
                    {rep.states.map(state => (
                        <div key={state.stateCode}>
                            <div className={s.row}>
                                <div>
                                    <p>
                                        <strong>
                                            {usaStatesList[state.stateCode] ||
                                                state.stateCode}
                                        </strong>
                                    </p>
                                </div>

                                <div>
                                    <p>{state.stateLeadsCount || 0}</p>
                                </div>
                            </div>

                            {state.areas.map(area => (
                                <div
                                    key={area.areaCode}
                                    className={classNames(s.row, s.subRow)}
                                >
                                    <div>
                                        <p>{area.areaCode}</p>
                                    </div>

                                    <div>
                                        <p>{area.areaLeadsCount}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/state/StateRepAssignedAreas.tsx